'use client'

import { TrustFactorBannerProps } from '@/widgets/landing-page-widgets/TrustFactorBanner/schema'
import { cn } from '@admin/lib/utils'
import { Typography } from '@pw-tech/omni-ui'
import Image from 'next/image'
import styles from './styles.module.css'

const TrustFactorBanner = ({ trustFactorData }: { trustFactorData: TrustFactorBannerProps }) => {
  return (
  <div className="md:py-[60px] py-10 bg-[#8c3c06] relative">
  <div className="opacity-5" style={{willChange: 'opacity'}}>
        <Image
          src={trustFactorData.backgroundPattern}
          layout='fill'
          objectFit='cover'
          objectPosition='top center'
          alt=''
          loading='lazy'
        />
      </div>
  <div className="max-w-6xl mx-auto px-4 md:px-6 text-white flex flex-col md:gap-10">
  <Typography variant='heading2' weight='bold' className="text-center">
          {trustFactorData.heading}
        </Typography>
  <div className="flex md:flex-row flex-col items-center gap-10 md:gap-0 px-4 md:px-[60px] justify-between mt-6 md:mt-0">
          <div className={cn("relative w-full h-full flex items-center justify-center md:block")}> 
            {trustFactorData?.bannerImages?.[0]?.banner && (
              <Image
                src={trustFactorData.bannerImages[0].banner}
                width={205}
                height={89}
                objectPosition='center'
                alt='Rating Iamge'
                loading='lazy'
              />
            )}
          </div>
          <div className={cn("relative w-full h-full flex items-center justify-center md:right-2")}> 
            {trustFactorData?.bannerImages?.[1]?.banner && (
              <Image
                src={trustFactorData.bannerImages[1].banner}
                width={247}
                height={81}
                alt='Playstore Image'
                loading='lazy'
              />
            )}
          </div>
          <div className={cn("relative w-full h-full flex items-center justify-center md:justify-end md:-right-10 md:left-0 -left-1")}> 
            {trustFactorData?.bannerImages?.[2]?.banner && (
              <Image
                src={trustFactorData.bannerImages[2].banner}
                width={280}
                height={88}
                alt='Physicswallah Logo'
                loading='lazy'
              />
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default TrustFactorBanner
